import { useQuery } from "@tanstack/react-query";
import { CloudOff, Loader2 } from "lucide-react";
import { useRole } from "@/contexts/RoleContext";
import { useOfflineSync } from "@/hooks/useOfflineSync";
import { useWorkSessionGuard } from "@/hooks/useWorkSessionGuard";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function CleanerRuntimeGuards() {
  const { currentOrgId } = useRole();
  const { pendingCount, isSyncing } = useOfflineSync();
  const { data: userId } = useQuery({
    queryKey: ["cleaner-session-user-id"],
    queryFn: async () => {
      const { data } = await supabase.auth.getUser();
      return data.user?.id ?? "";
    },
    staleTime: Infinity,
  });

  const {
    resumeSession,
    isResolving,
    continueSession,
    endSessionFromPrompt,
  } = useWorkSessionGuard({
    enabled: Boolean(userId && currentOrgId),
    userId: userId || null,
    orgId: currentOrgId,
  });

  return (
    <>
      {pendingCount > 0 && (
        <div className="fixed bottom-4 left-1/2 z-40 flex -translate-x-1/2 items-center gap-2 rounded-full border bg-background/95 px-3 py-1.5 text-xs shadow-md">
          {isSyncing ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <CloudOff className="h-3.5 w-3.5" />}
          <span>
            {isSyncing
              ? "Wysyłanie zapisów offline…"
              : `Oczekuje na sieć: ${pendingCount} ${pendingCount === 1 ? "zapis" : "zapisy"}`}
          </span>
        </div>
      )}

      <AlertDialog open={Boolean(resumeSession)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Otwarta sesja pracy</AlertDialogTitle>
            <AlertDialogDescription>
              Masz niezakończoną sesję
              {resumeSession?.location_address ? ` w ${resumeSession.location_address}` : ""}.
              Kontynuować sprzątanie czy zakończyć czas pracy?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <Button variant="outline" onClick={() => void endSessionFromPrompt()} disabled={isResolving}>
              Zakończ sesję
            </Button>
            <Button onClick={continueSession} disabled={isResolving}>
              Kontynuuj
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
